import React,{useState,useEffect} from "react"
import {useLocation as location2} from 'wouter';
import Alert from "../components/Alert";
import Loading from "../components/Loading";
import post from "../post";

const RegisterTicket = () => {
    const [location, navigate] = location2(); 
    const [loading, setLoading] = useState(false);
    const [canAccumulate, setCanAccumulate] = useState(false);
    const [error,setError]=useState(null);
    const [expPoints,setExpPoints]=useState('-');
    const [ticketNumber, setTicketNumber] = useState('');
    const [orderDate, setOrderDate] = useState('');
    const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });
    const user_id= localStorage.getItem('token');
    if(!user_id){
        navigate('/login');
    }
    const addPoints = async () => {
        setLoading(true);
        const sendPoints = await post('addPuntos', { ticketNumber: ticketNumber, orderDate: orderDate }, true);
        setLoading(false);
        if(sendPoints.result){
            setAlert({ isOpen: true, title: '¡Puntos acumulados!', message: `Puntos acumulados con éxito` ,onClose:()=>{navigate('/')}});
           
        } else {
            setAlert({ isOpen: true, title: 'Error', message: sendPoints.message || 'No se pudieron acumular los puntos. Inténtalo de nuevo más tarde.' });
        }
    }
    useEffect(() => {
        if(!canAccumulate) return;
        if(ticketNumber.length<5) return;
        const findPoints = async () => {
            setExpPoints(-1)
            setError(null);
            const response = await post('/findPuntos', { ticketNumber: ticketNumber, orderDate: orderDate }, true);
            if(response.result){
                setExpPoints(response.data);
            }else{
                setError(response.motive);
                setExpPoints(0);
            }
        };
        findPoints();
    }, [canAccumulate,ticketNumber,orderDate]);
    return (
        <div id="webcrumbs">
            <Alert
                isOpen={alert.isOpen}
                title={alert.title}
                message={alert.message}
                onClose={() => alert.onClose?alert.onClose()  : setAlert({ isOpen: false, title: '', message: '' })}
            />
            <Loading isOpen={loading} />
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center text-neutral-700">
                <button 
                className="absolute top-4 left-4 z-10 w-10 h-10 bg-neutral-200 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
                onClick={()=>{navigate('/');}}
            >
                <span className="material-symbols-outlined text-primary-600">arrow_back</span>
            </button>
                <div className="w-full max-w-3xl px-6 py-10">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">confirmation_number</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Acumular Puntos</h1>
                        <p className="text-neutral-600 text-center">
                            
                            Ingrese los datos de su pedido para acumular puntos de fidelidad
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        <div className="space-y-6">
                            <div className="space-y-4">
                                <div>
                                    <label
                                        htmlFor="ticket-number"
                                        className="block text-sm font-medium text-neutral-700 mb-2"
                                    >
                                        Número de ticket
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            id="ticket-number"
                                            placeholder="Ej: WS7YTX9"
                                            className="w-full px-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all placeholder-neutral-400"
                                            onChange={(e) => {
                                                setTicketNumber(e.target.value);
                                                setCanAccumulate(e.target.value.trim() !== '' && e.target.value.trim().length>=5 && orderDate !== '');
                                            }}
                                        />
                                        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 material-symbols-outlined text-neutral-400">
                                            receipt_long
                                        </span>
                                    </div>
                                    {error ? (<p className="text-xs text-red-500 mt-1">{error}</p>) : (
                                        <p className="text-xs text-neutral-500 mt-1">
                                            Ingrese el número de ticket que aparece en su recibo
                                        </p>
                                    )}
                                </div>

                                <div>
                                    <label
                                        htmlFor="order-date"
                                        className="block text-sm font-medium text-neutral-700 mb-2"
                                    >
                                        Fecha del pedido
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="date"
                                            id="order-date"
                                            className="w-full px-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
                                            onChange={(e) => {
                                                setOrderDate(e.target.value);
                                                setCanAccumulate(e.target.value !== '' && ticketNumber.trim() !== '' && ticketNumber.trim().length>=5);
                                            }}
                                        />
                                        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 material-symbols-outlined text-neutral-400">
                                            calendar_today
                                        </span>
                                    </div>
                                    <p className="text-xs text-neutral-500 mt-1">
                                        Seleccione la fecha en la que realizó su pedido
                                    </p>
                                </div>
                            </div>

                            <div className="bg-primary-50 border border-primary-100 rounded-xl p-4">
                                <div className="flex items-start space-x-3">
                                    <span className="material-symbols-outlined text-primary-600 mt-0.5">info</span>
                                    <div>
                                        <h4 className="font-medium text-primary-800 mb-1">Información importante</h4>
                                        <ul className="text-sm text-primary-700 space-y-1">
                                            <li>• Los puntos se acumularán automáticamente en su cuenta</li>
                                            <li>
                                                • Solo puede acumular puntos dentro de los 30 días posteriores al pedido
                                            </li>
                                            <li>• Cada euro gastado equivale a 1 punto</li>
                                            <li>• Los puntos estarán disponibles en 24-48 horas</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="border-t border-neutral-100 pt-6">
                                <div className="flex items-center justify-between mb-4">
                                    <span className="font-medium text-neutral-700">Puntos estimados a acumular:</span>
                                    {(expPoints>=0 || expPoints==='-') ? (
                                        <div className="flex items-center space-x-1">
                                            <span className="material-symbols-outlined text-primary-600">stars</span>
                                            <span className="font-bold text-primary-600">{expPoints} puntos</span>
                                        </div>
                                    ) : (
                                        <div className="w-5 h-5 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
                                    )}
                                </div>

                                <div className="text-xs text-neutral-500 mb-6">
                                    Los puntos exactos se calcularán basándose en el monto total de su pedido
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <button
                                    type="button"
                                    className="w-full flex items-center justify-center space-x-2 bg-neutral-200 text-neutral-800 py-3.5 rounded-xl font-medium shadow-sm hover:bg-neutral-300 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                    onClick={() => navigate('/')}
                                >
                                    <span className="material-symbols-outlined">arrow_back</span>
                                    <span>Cancelar</span>
                                </button>
                                <button
                                    type="button"
                                    className="w-full flex items-center justify-center space-x-2 bg-primary-600 text-white py-3.5 rounded-xl font-medium shadow-sm hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99] disabled:bg-neutral-200 disabled:text-neutral-400 disabled:cursor-not-allowed"
                                    disabled={!canAccumulate}
                                    onClick={addPoints}
                                >
                                    <span className="material-symbols-outlined">add_circle</span>
                                    <span>Acumular puntos</span>
                                </button>
                            </div>

                            {/*<div className="text-center mt-4">
                                <a
                                    href="#"
                                    className="inline-flex items-center text-primary-600 hover:text-primary-700 transition-colors"
                                >
                                    <span className="material-symbols-outlined text-sm mr-1">help</span>
                                    ¿No encuentra su número de ticket?
                                </a>
                            </div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default RegisterTicket;